import { IconWrapper, IconWrapperProps } from './IconWrapper';

interface RemoveIconProps extends IconWrapperProps {}

export const RemoveIcon = ({ ...props }: RemoveIconProps) => (
  <IconWrapper {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.7071 1.70711C11.0976 1.31658 11.0976 0.683417 10.7071 0.292893C10.3166 -0.0976311 9.68342 -0.0976311 9.29289 0.292893L5.5 4.08579L1.70711 0.292893C1.31658 -0.0976311 0.683417 -0.0976311 0.292893 0.292893C-0.0976311 0.683417 -0.0976311 1.31658 0.292893 1.70711L4.08579 5.5L0.292893 9.29289C-0.0976311 9.68342 -0.0976311 10.3166 0.292893 10.7071C0.683417 11.0976 1.31658 11.0976 1.70711 10.7071L5.5 6.91421L9.29289 10.7071C9.68342 11.0976 10.3166 11.0976 10.7071 10.7071C11.0976 10.3166 11.0976 9.68342 10.7071 9.29289L6.91421 5.5L10.7071 1.70711Z"
      fill="#333333"
    />
  </IconWrapper>
);

RemoveIcon.displayName = 'RemoveIcon';
